// Redux action types
export const SET = 'one-state-alerts-nextgen/set';
export const REINIT = 'one-state-alerts-nextgen/reinit';